// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"651":"2c009461","686":"e08eb121","858":"d7dbeaa7"}[chunkId] + ".chunk.js";
};